export default __webpack_public_path__ + "static/media/WinterClothes_14.8925cb6a.png";